export const isValidPhoneNumber = (number) => {
  return (number.match(/\d/g) || []).length >= 10
}